import { useAppStore } from '@/inertia/AppStore';
import { Box, Grid, type GridProps } from '@mui/material';
import { useMemo } from 'react';
import { PAGE_LAYOUT } from '../Page';
import GridView from './GridView';
import Player from './Player';
import Share from './Share';
import SideBar from './SideBar';

type MainContainerProps = {
  listView?: {
    containerGridProps?: GridProps;
    rightGridElements?: React.ReactNode;
    rightGridProps?: GridProps;
    leftGridProps?: GridProps;
  };
  className?: string;
  isFallback?: boolean;
};

const MainContainer = (props: MainContainerProps) => {
  const barView = useAppStore((state) => state.barView);
  const isLoadingVertexSearch = useAppStore((state) => state.isLoadingVertexSearch);

  const isFallback = useMemo(
    () => props?.isFallback || isLoadingVertexSearch,
    [props?.isFallback, isLoadingVertexSearch]
  );

  return (
    <>
      <Box sx={{ mt: 1 }} />
      {/* Grid View */}
      <Grid
        container
        {...PAGE_LAYOUT.centerProps}
        columns={12}
        className={`grid-view ${props?.className ?? ''} z-${barView === 'grid' ? 'show' : 'hide'}`}
      >
        <GridView isFallback={isFallback} />
      </Grid>

      {/* List View */}
      <Grid
        sx={{ mb: 1 }}
        {...PAGE_LAYOUT.centerProps}
        {...props?.listView?.containerGridProps}
        container
        className={`list-view ${props?.className ?? ''} z-${barView === 'list' ? 'show' : 'hide'}`}
      >
        <Grid {...PAGE_LAYOUT.leftProps} {...props?.listView?.leftGridProps}>
          <Player isFallback={isFallback} />
        </Grid>
        <Grid {...PAGE_LAYOUT.rightProps} {...props?.listView?.rightGridProps}>
          {props?.listView?.rightGridElements ? (
            props?.listView?.rightGridElements
          ) : (
            <>
              <Share isFallback={isFallback} />
              <SideBar isFallback={isFallback} />
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default MainContainer;
